import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=15b72e6c&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b72e6c')) {
      api.createRecord('15b72e6c', component.options)
    } else {
      api.reload('15b72e6c', component.options)
    }
    module.hot.accept("./Layout.vue?vue&type=template&id=15b72e6c&", function () {
      api.rerender('15b72e6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "backoffice/themes/base/src/views/Layout/Layout.vue"
export default component.exports